import React from 'react';

import { isFunction } from '../../lib/typeCheckers';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import { Trigger, TriggerButtonProps } from '../DropdownMenu/TriggerButton';

export const appMenuCID = 'CID-AppMenu';

export interface AppMenuProps {
  children: React.ReactNode | ((props: AppMenuChildProps) => React.ReactNode);
  title?: string;
  trigger: Trigger<TriggerButtonProps>;
}

export interface AppMenuChildProps {
  handleClose: () => void;
}

const AppMenu: React.FC<AppMenuProps> = ({ children, title, trigger }) => {
  return (
    <DropdownMenu disablePadding className={appMenuCID} title={title ?? 'App Menu'} trigger={trigger}>
      {({ handleClose }) => (
        <>
          {isFunction(children)
            ? children({
                handleClose,
              })
            : children}
        </>
      )}
    </DropdownMenu>
  );
};

export default AppMenu;
